module.exports = __webpack_public_path__ + "static/media/ic_hospicash_b3_fisdom.81d8e240.svg";